import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { LanguageProvider, useLang } from "./i18n/LanguageContext";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import AirportTransfers from "./pages/AirportTransfers";
import Fleet from "./pages/Fleet";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Book from "./pages/Book";
import Admin from "./pages/Admin";
import RouteDetail from "./pages/RouteDetail";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NotFound = () => {
  const { t } = useLang();
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6 pt-24">
      <div className="text-center">
        <div className="font-display text-[10rem] md:text-[14rem] font-black text-zinc-900 leading-none hl-yellow inline-block">404</div>
        <h1 className="font-display text-2xl md:text-4xl font-black text-zinc-900 uppercase tracking-tight mb-3 mt-4">Page Not Found</h1>
        <p className="text-zinc-600 mb-6">The route you are looking for doesn't exist.</p>
        <Link to="/" className="bt-btn-primary">{t.common.backToHome}</Link>
      </div>
    </div>
  );
};

const PublicLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <WhatsAppFloat />
  </>
);

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
      <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
      <Route path="/airport-transfers" element={<PublicLayout><AirportTransfers /></PublicLayout>} />
      <Route path="/fleet" element={<PublicLayout><Fleet /></PublicLayout>} />
      <Route path="/pricing" element={<PublicLayout><Pricing /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/book" element={<PublicLayout><Book /></PublicLayout>} />
      <Route path="/:slug" element={<PublicLayout><RouteDetail /></PublicLayout>} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
          <Toaster theme="light" position="top-center" />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
